@import 'common/component';

:host {
  display: block;
  position: relative;
  min-width: var(--o2-menu-width, $component-min-width);
  z-index: 1000;
}

.menu {
  position: relative;
  display: none;
  max-height: inherit;
  overflow: auto;
  border-radius: $border-radius;
  border: 1px solid $border-primary;
  background: $background-main-primary;

  &--open {
    display: block;
  }

  &--shadow-bottom {
    box-shadow: 0 0.8rem 1.6rem -0.4rem rgba(2, 6, 23, 0.15);
  }

  &--shadow-top {
    box-shadow: 0 -0.8rem 1.6rem -0.4rem rgba(2, 6, 23, 0.15);
  }
}

.menu {
  animation: o2MenuFadeIn 0.3s ease-in-out;
}


@keyframes o2MenuFadeIn {
  from {
    opacity: 0;
    transform: translateY(-1rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
